import { propertyQueryKeys as e } from "../usePropertiesQueryKeys.mjs";
import { runPropertyMediaUpload as t } from "../media/runPropertyMediaUpload.mjs";
import { useMutation as n, useQueryClient as r } from "@maat/store-hooks";
import { propertiesApi as i } from "@maat/api-main";
//#region src/properties/gallery/useUpdatePropertyGalleryMutation.ts
var a = () => {
	let a = r();
	return n({
		mutationFn: ({ propertyId: e, deletes: n = [], keep: r = [], additions: a = [], onUploadProgress: o }) => t({
			propertyId: e,
			groups: a,
			carriesEdits: !0,
			presign: (t) => i.presignPropertyImageEdits(e, {
				updates: {
					deletes: n,
					keep: r
				},
				media: t.length > 0 ? t : void 0
			}),
			onUploadProgress: o
		}),
		onSuccess: (t, { propertyId: n }) => {
			a.invalidateQueries({ queryKey: e.gallery(n) }), a.invalidateQueries({ queryKey: e.images(n) }), a.invalidateQueries({ queryKey: e.property(n) }), a.invalidateQueries({ queryKey: e.unit() }), a.invalidateQueries({ queryKey: e.hostFeed() });
		}
	});
};
//#endregion
export { a as useUpdatePropertyGalleryMutation };
